module.exports = __webpack_public_path__ + "static/media/notebook-09.c8240a0e.png";